function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.301998,
  d: "M61.4846 83.2014C68.8033 82.0122 71.7655 81.1176 78.911 74.1686C86.0565 67.2197 93.3021 77.3578 104.048 73.2875C114.794 69.2171 115.776 64.289 132.212 79.3848C139.788 85.8006 145.815 83.2606 149.528 85.8006C152.004 87.4938 154.39 91.6679 156.687 98.3227H150.699H61.4846C53.9045 95.6607 50.1145 93.4498 50.1145 91.69C50.1145 89.0505 54.166 84.3905 61.4846 83.2014Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.301998,
  d: "M164.851 101.737C170.514 100.858 172.807 100.196 178.336 95.0602C183.865 89.9241 189.472 97.4175 197.787 94.409C206.102 91.4004 206.862 87.7579 219.581 98.9157C225.443 103.658 230.106 101.78 232.98 103.658C234.896 104.909 236.742 107.994 238.52 112.913H233.886H164.851C158.986 110.946 156.053 109.311 156.053 108.011C156.053 106.06 159.188 102.616 164.851 101.737Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M103.241 52.6489H158.808C159.118 52.6489 159.369 52.9001 159.369 53.21V118.033C159.369 122.165 156.02 125.514 151.888 125.514H103.803C103.493 125.514 103.241 125.263 103.241 124.953V52.6489Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M119.006 105.691H137.503V119.458H119.343L119.006 105.691Z",
  fill: "#E9E9EF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M144.042 118.781C144.042 122.375 146.858 125.312 150.404 125.504C150.282 125.511 150.159 125.514 150.035 125.514H98.5158C94.384 125.514 91.0344 122.165 91.0344 118.033V112.12L130.611 112.12C130.749 108.566 133.662 105.715 137.255 105.691L137.308 105.691C140.925 105.691 143.876 108.542 144.035 112.12L144.042 112.12L144.041 112.385C144.042 112.398 144.042 112.411 144.042 112.424V118.781Z",
  fill: "url(#paint3_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M89.6096 105.691H130.329C130.639 105.691 130.89 105.942 130.89 106.252V151.863C130.89 155.226 128.163 157.953 124.8 157.953H84.1856C83.8757 157.953 83.6245 157.702 83.6245 157.392V111.676C83.6245 108.37 86.3041 105.691 89.6096 105.691Z",
  fill: "url(#paint4_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M118.353 146.507L118.354 152.278C118.354 155.412 120.895 157.953 124.029 157.953L124.005 157.953C123.997 157.953 123.989 157.953 123.981 157.953H83.6394C77.7367 157.953 72.9517 153.168 72.9517 147.265V146.507H118.353Z",
  fill: "url(#paint5_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M195.214 144.826C195.9 144.826 196.455 145.381 196.455 146.066V156.391C196.455 157.077 195.9 157.632 195.214 157.632C194.529 157.632 193.974 157.077 193.974 156.391V146.066C193.974 145.381 194.529 144.826 195.214 144.826Z",
  fill: "#F0F0F3",
  fillOpacity: 0.9
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M192.67 129.546C190.366 134.331 182.431 149.006 193.549 150.649C204.667 152.292 204.171 142.524 202.221 139.029C200.271 135.533 198.07 133.576 198.07 129.546C198.07 125.517 194.975 124.762 192.67 129.546Z",
  fill: "url(#paint6_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M215.284 140.078H215.404C215.745 140.078 216.021 140.354 216.021 140.694V147.187C216.021 147.527 215.745 147.803 215.404 147.803H215.284C214.944 147.803 214.668 147.527 214.668 147.187V140.694C214.668 140.354 214.944 140.078 215.284 140.078Z",
  fill: "#F0F0F3",
  fillOpacity: 0.9
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M213.807 130.218C212.303 133.223 207.121 142.441 214.381 143.473C221.642 144.505 221.318 138.37 220.044 136.174C218.771 133.979 217.334 132.749 217.334 130.218C217.334 127.687 215.312 127.213 213.807 130.218Z",
  fill: "url(#paint7_linear)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M164.629 93.1334C163.486 92.8328 162.132 92.9873 162.042 93.8404C161.982 94.4092 162.765 94.5687 164.39 94.3191C166.94 96.2804 169.134 98.0192 170.971 99.5355C173.726 101.81 173.907 100.482 172.647 99.2999C171.387 98.1178 172.714 96.6385 172.056 96.4984C167.866 94.4555 165.39 93.3339 164.629 93.1334Z",
  fill: "#FFB8A3"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M121.163 72.9485H86.273C85.9227 72.9485 85.6387 73.2325 85.6387 73.5828V76.7547C85.6387 77.105 85.9227 77.389 86.273 77.389H121.163C121.513 77.389 121.797 77.105 121.797 76.7547V73.5828C121.797 73.2325 121.513 72.9485 121.163 72.9485Z",
  fill: "url(#paint8_linear)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.4229 80.5605H121.48C121.831 80.5605 122.115 80.8446 122.115 81.1949V84.3667C122.115 84.7171 121.831 85.0011 121.48 85.0011H96.4229C96.0726 85.0011 95.7886 84.7171 95.7886 84.3667V81.1949C95.7886 80.8446 96.0726 80.5605 96.4229 80.5605Z",
  fill: "url(#paint9_linear)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M98.9602 116.085H90.0792C89.7288 116.085 89.4448 116.369 89.4448 116.719V125.6C89.4448 125.951 89.7288 126.235 90.0792 126.235H98.9602C99.3106 126.235 99.5946 125.951 99.5946 125.6V116.719C99.5946 116.369 99.3106 116.085 98.9602 116.085Z",
  fill: "url(#paint10_linear)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M105.304 116.085H125.603C125.954 116.085 126.238 116.369 126.238 116.719V118.622C126.238 118.973 125.954 119.257 125.603 119.257H105.304C104.953 119.257 104.669 118.973 104.669 118.622V116.719C104.669 116.369 104.953 116.085 105.304 116.085Z",
  fill: "url(#paint11_linear)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M105.304 123.063H125.603C125.954 123.063 126.238 123.347 126.238 123.697V125.6C126.238 125.951 125.954 126.235 125.603 126.235H105.304C104.953 126.235 104.669 125.951 104.669 125.6V123.697C104.669 123.347 104.953 123.063 105.304 123.063Z",
  fill: "url(#paint12_linear)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M90.0792 130.041H125.603C125.954 130.041 126.238 130.325 126.238 130.675V132.578C126.238 132.929 125.954 133.213 125.603 133.213H90.0792C89.7288 133.213 89.4448 132.929 89.4448 132.578V130.675C89.4448 130.325 89.7288 130.041 90.0792 130.041Z",
  fill: "url(#paint13_linear)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M155.963 141.98L145.903 143.679",
  stroke: "#E0E0EA",
  strokeWidth: 3.52423,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M157.507 131.929L147.806 133.53",
  stroke: "#E0E0EA",
  strokeWidth: 3.52423,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M167.199 128.726L157.956 130.358",
  stroke: "#E0E0EA",
  strokeWidth: 3.52423,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M169.058 137.019L156.699 139.503",
  stroke: "#E0E0EA",
  strokeWidth: 3.52423,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M171.595 145.265L155.101 148.437",
  stroke: "#E0E0EA",
  strokeWidth: 3.52423,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M158.908 121.794L149.075 123.38",
  stroke: "#E0E0EA",
  strokeWidth: 3.52423,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M163.348 117.988L153.515 119.574",
  stroke: "#E0E0EA",
  strokeWidth: 3.52423,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M164.979 160.828L150.978 111.044L143.366 158.904",
  stroke: "#E0E0EA",
  strokeWidth: 3.52423,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M175.446 157.623L161.445 107.838L153.833 155.698",
  stroke: "#E0E0EA",
  strokeWidth: 3.52423,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.069 88.7761C169.808 89.7385 169.049 92.7024 169.786 93.4983C170.1 93.8372 170.851 94.2793 171.678 94.3516C171.48 94.716 171.305 95.0251 171.152 95.2788C170.698 96.0337 170.186 96.4839 169.615 96.6294L174.585 97.8471C173.958 97.1433 173.633 96.4559 173.609 95.7848C173.594 95.352 173.695 94.6817 173.913 93.7739C174.96 93.1979 175.842 92.2617 176.107 91.2311C176.759 88.7018 172.33 87.8138 171.069 88.7761Z",
  fill: "url(#paint14_linear)"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.494 94.8011C175.224 93.241 176.684 91.4702 176.805 90.6033C176.887 90.0254 176.696 89.58 176.233 89.2672C176.363 88.1107 175.678 87.3549 174.177 86.9999C173.842 86.9208 173.273 87.1101 172.953 86.9703C172.38 86.7199 172.207 86.5961 171.791 86.4932C171.244 86.3578 170.847 86.4991 170.518 86.8481C170.114 87.2763 170.116 88.0894 170.585 88.7823C171.006 89.4058 171.672 89.3846 172.03 89.6849C172.269 89.886 172.462 90.6791 172.609 92.0642L172.822 91.724C173.296 91.0634 173.689 90.8832 174 91.1834C174.311 91.4835 174.287 91.8339 173.928 92.2343C173.406 93.0674 173.121 93.6219 173.073 93.8979C173.024 94.1739 173.165 94.475 173.494 94.8011Z",
  fill: "#353564"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M164.375 98.043L159.658 97.7428C158.422 96.2806 157.643 95.0701 157.322 94.1112C156.84 92.6728 158.259 91.9144 156.622 90.6014C154.984 89.2884 155.822 95.9068 156.183 96.8163C156.545 97.7258 157.288 99.5667 159.847 100.804C162.406 102.041 165.542 100.748 165.952 100.523L164.375 98.043Z",
  fill: "url(#paint15_linear)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.742 142.636C170.503 143.307 169.66 143.608 169.21 143.538C168.537 143.433 168.08 144.107 168.656 144.6C169.233 145.092 171.312 144.836 171.826 144.917C172.34 144.997 173.634 145.429 173.354 143.563C173.167 142.318 172.92 141.763 172.615 141.896L171.819 142.028L171.742 142.636Z",
  fill: "#3E3E6E"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M162.24 127.336C161.218 128.305 160.481 128.814 160.029 128.862C159.351 128.935 159.084 129.705 159.768 130.032C160.453 130.358 162.394 129.573 162.912 129.517C163.429 129.462 164.791 129.544 164.037 127.814C163.535 126.661 163.153 126.188 162.893 126.395L162.157 126.729L162.24 127.336Z",
  fill: "#3E3E6E"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M177.413 110.81C178.595 116.022 176.802 118.167 172.034 117.246C164.882 115.864 162.196 112.798 162.929 119.573C163.417 124.089 163.667 126.449 163.677 126.652C162.29 127.179 161.597 127.135 161.597 126.522C161.597 125.602 155.916 110.74 160.561 109.594C163.657 108.83 169.275 109.236 177.413 110.81Z",
  fill: "url(#paint16_linear)"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M170.162 114.304C170.162 114.304 169.553 116.808 169.616 121.483C169.711 128.569 170.602 139.196 171.589 142.207C171.805 142.176 172.398 142.176 173.367 142.207C175.867 128.826 177.253 120.969 177.526 118.637C177.935 115.138 177.977 110.848 177.072 110.523C174.088 109.452 170.162 112.913 170.162 114.304Z",
  fill: "url(#paint17_linear)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M170.379 95.9889C171.225 96.3248 171.598 97.9636 173.978 96.5145C174.276 96.4737 178.16 97.7704 177.447 101.174C176.734 104.578 178.438 113.168 177.447 114.582C176.456 115.997 167.314 116.279 166.49 112.705C165.94 110.322 165.787 106.707 166.028 101.86C163.996 102.346 162.833 102.531 162.541 102.415C162.102 102.24 161.994 100.989 161.994 100.255C161.994 99.5199 161.813 98.4138 162.541 97.922C163.268 97.4301 169.533 95.6531 170.379 95.9889Z",
  fill: "#5B5BEA"
});

var _ref37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 103.401,
  y1: 69.1421,
  x2: 103.401,
  y2: 98.3227,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCDCE4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DEDEE6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 197.286,
  y1: 91.345,
  x2: 197.286,
  y2: 112.913,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCDCE4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DEDEE6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 134.564,
  y1: 52.6489,
  x2: 134.564,
  y2: 126.186,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFAFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 120.719,
  y1: 124.31,
  x2: 120.719,
  y2: 107.953,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEEEF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDBDC8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 107.257,
  y1: 105.691,
  x2: 107.257,
  y2: 170.262,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9E9EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFAFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 98.4903,
  y1: 146.507,
  x2: 98.4903,
  y2: 163.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAFAFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E3E3EF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 195.542,
  y1: 126.235,
  x2: 195.542,
  y2: 150.834,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBEBEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFCFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 215.683,
  y1: 128.138,
  x2: 215.683,
  y2: 143.589,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBEBEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFCFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 104.617,
  y1: 78.0963,
  x2: 104.617,
  y2: 72.9485,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDFDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7E7ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 109.606,
  y1: 85.7083,
  x2: 109.606,
  y2: 80.5605,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDFDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7E7ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 94.5197,
  y1: 116.085,
  x2: 94.5197,
  y2: 126.235,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFAFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 115.454,
  y1: 116.085,
  x2: 115.454,
  y2: 119.257,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFAFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 115.454,
  y1: 123.063,
  x2: 115.454,
  y2: 126.235,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFAFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 107.841,
  y1: 130.041,
  x2: 107.841,
  y2: 133.213,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFAFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 171.91,
  y1: 90.7587,
  x2: 173.072,
  y2: 95.7689,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD2C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB8A3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 166.095,
  y1: 104.541,
  x2: 154.29,
  y2: 96.2888,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD2C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB8A3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 163.12,
  y1: 125.158,
  x2: 167.664,
  y2: 110.755,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7878C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C5CBB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: 173.562,
  y1: 140.686,
  x2: 175.758,
  y2: 111.711,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7878C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C5CBB"
})));

var SvgSetting = function SvgSetting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 216,
    viewBox: "0 0 288 216",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSetting, _extends({
    svgRef: ref
  }, props));
});
export default "https://sf16-website.neutral.ttwstatic.com/obj/tiktok_web_static/bytecom/api_gateway_web_i18n/static/media/setting.43939464.svg";
export { ForwardRef as ReactComponent };